/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ImportJobRequest {
  connection_id: string;
  remote_job_id: string;
  project_id: string;
  employer_id: string;
  job_manager_id?: string | null;
}
